import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-search-offline",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./offline-search.component.html",
  styleUrls: ["./offline-search.component.scss"]
})
export class SearchOfflineComponent {
  @Input() title = "Search is offline";
  @Input() subtitle = "Reconnect to continue searching.";
}
